import "babel-polyfill";
import "isomorphic-fetch";
import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import {flashMessage} from "redux-flash";
import {Provider} from "react-redux";
import {createStore, applyMiddleware} from "redux";
import thunkMiddleware from "redux-thunk";
import {Router, Route, Redirect, browserHistory} from "react-router";
import {syncHistoryWithStore, routerMiddleware} from "react-router-redux";
import {middleware as flashMiddleware} from "redux-flash";
import {persistStore, persistReducer} from "redux-persist";
import {composeWithDevTools} from "redux-devtools-extension";
import {createHistory, useBasename} from "history";
import {
    loadTranslations,
    syncTranslationWithStore,
    setLocale
} from "react-redux-i18n";
import {PersistGate} from "redux-persist/es/integration/react";
import storage from "redux-persist/lib/storage";
import reducers from "./store/reducers";
import translations from "./config/translations";
import Config from "./config";
import asyncComponent from "./AsyncComponent";
import {LocalizeProvider} from "react-localize-redux";

var client = 'electrolux-elucid';

/**
 * Async components: Frontend Layout
 */
const FrontLayout = asyncComponent(() =>
    import("./Layouts/FrontLayout")
);
/**
 * Async components: Frontend
 */

var Home = null;
Home = asyncComponent(() =>
    import("./pages/Home"),
);

/**
 * Middleware
 */
const middleware = [
    thunkMiddleware,
    flashMiddleware(),
    routerMiddleware(browserHistory)
];

/**
 * Persist
 */
const persist = persistReducer(
    {
        key: "root",
        storage: storage,
        blacklist: ["flash", "routing", "media", "i18n"]
    },
    reducers
);

/**
 * Store configuration
 */
let store;
if (process.env.NODE_ENV === "development") {
    store = createStore(
        persist,
        composeWithDevTools(applyMiddleware(...middleware))
    );
} else {
    store = createStore(persist, applyMiddleware(...middleware));
}

/**
 * Language sync
 */
syncTranslationWithStore(store);
store.dispatch(loadTranslations(translations));
store.dispatch(setLocale(Config.language));
//store.dispatch(pingMe());

const gate = persistStore(store);
const basename = window.location.pathname + window.location.search;

const bh = useBasename(createHistory)({
    basename: basename === "/" ? "" : ""
});

const history = syncHistoryWithStore(bh, store);

/**
 * Get renderer
 */
let initialLoad = true;
let initialRoute = "customer";

/**
 * Configure axios
 */
axios.interceptors.response.use(
    response => {
        return response;
    },
    function (error) {
        store.dispatch(
            flashMessage("Something went wrong. Please try again!", {
                timeout: 6000,
                props: {
                    type: "error"
                }
            })
        );

        return Promise.reject(error);
    }
);

console.log("Leaderboard version:",Config.version);

/**
 * With Frontend layout
 */
const withFrontendLayout = (WrappedComponent, frontendTheme, pageId) => {
    return class WithAuthorization extends React.Component {
        componentDidMount() {
            document.body.classList.remove("admin-page");
            document.body.classList.add("front-page");
            if (frontendTheme) {
                document.body.classList.add(frontendTheme);
            }
        }

        componentWillMount() {
            const {
                location: {pathname}
            } = this.props;

            if (initialLoad && initialRoute) {
                if (initialRoute !== pathname && pathname === "/") {
                    //window.location.replace("/");
                    initialLoad = false;
                }
            }
        }

        render() {
            let props = this.props;
            if (pageId) {
                props.params.page = pageId;
            }
            return (
                <FrontLayout {...props} frontendTheme={frontendTheme}>
                    <WrappedComponent {...props} frontendTheme={frontendTheme}/>
                </FrontLayout>
            );
        }
    };
};

/**
 * Frontend routes
 */
ReactDOM.render(
    <Provider store={store}>
        <PersistGate persistor={gate}>
            <LocalizeProvider>
                <Router history={history}>
                    <Route path="/" component={withFrontendLayout(Home, client)}/>
                    <Route path="/sso-success" component={withFrontendLayout(Home, client)}/>
                    <Route
                        path="/leader-board"
                        component={withFrontendLayout(Home, client)}
                    />
                    <Redirect from="*" to="/"/>
                </Router>
            </LocalizeProvider>
        </PersistGate>
    </Provider>,
    document.getElementById("application")
);

export {basename, store};


// WEBPACK FOOTER //
// ./src/index.js